// DEV-ONLY: mounts the floating store-override panel into <body>, outside the
// Nuxt app tree, so it appears on every page/layout without touching any of
// them. Entirely absent from production builds — `import.meta.dev` is a static
// `false` there, so this plugin body tree-shakes away.
import { createApp } from "vue";
import DevStorePanel from "~/components/dev/DevStorePanel.vue";

export default defineNuxtPlugin(() => {
  if (!import.meta.dev) return;
  if (!import.meta.client) return;

  const host = document.createElement("div");
  host.id = "dev-store-panel-host";
  document.body.appendChild(host);
  createApp(DevStorePanel).mount(host);
});
